import { FC } from "react";
import styles from "./Head.module.sass";

export const Head: FC = () => {
	const tableTitles = [
		"№",
		"Наименование объекта",
		"Тип объекта",
		"Сфера (область) деятельности, в которой функционирует объект",
		"Планируемый срок категорирования объекта",
		"Должность, фамилия, имя, отчество (при наличии) представителя, его телефон, адрес электронной почты (приналичии)",
	];

	return (
		<table className={styles["table-head"]}>
			<thead className={styles.head}>
				<tr className={styles.row}>
					{tableTitles.map((title, i) => (
						<th key={i} className={styles.cell}>
							{title}
						</th>
					))}
				</tr>
			</thead>
		</table>
	);
};
